import { ArrowTopRightOnSquareIcon, ViewColumnsIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import IconButton from "../../ui/buttons/IconButton";
import { useWorkspace } from "./useWorkspace";
import type { AppPath, Placement } from "./workspaceTypes";

/** The places these actions offer, each with its words and icon. */
const OFFERED = [
  { placement: "newTab", label: "shell.tabs.openNewTab", Icon: ArrowTopRightOnSquareIcon },
  { placement: "beside", label: "shell.tabs.openBeside", Icon: ViewColumnsIcon },
] as const;

/**
 * "Open in new tab" and "Open beside" for a result that opens a page (F90 Q2, TR-B4-02): the
 * same as Ctrl+click and Alt+click on its link, for those who don't know the keys. The place a
 * plain click on the result already opens isn't offered again (F140). They go through the
 * workspace's one `open`.
 */
export default function TabOpenActions({ route, plainClick }: { route: AppPath; plainClick: Placement }) {
  const { t } = useTranslation();
  const workspace = useWorkspace();
  return (
    <span className="flex shrink-0 flex-col gap-0.5">
      {OFFERED.filter((each) => each.placement !== plainClick).map(({ placement, label, Icon }) => (
        <IconButton key={placement} label={t(label)} title={t(label)} className="h-6 w-6 p-1" onClick={() => { workspace.open(route, { placement }); }}>
          <Icon className="h-4 w-4" aria-hidden="true" />
        </IconButton>
      ))}
    </span>
  );
}
